import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a4d4729a = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _faeaaf38 = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _0b2f08fe = () => interopDefault(import('../pages/apple-iphone-17-zubehoer.vue' /* webpackChunkName: "pages/apple-iphone-17-zubehoer" */))
const _dfd87454 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _b912827a = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _3ba07298 = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _4245c694 = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _05803029 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _8c6fd928 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _4922ef13 = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _c90d6b30 = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _4dc76a18 = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _ff3a89da = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _75450ff8 = () => interopDefault(import('../pages/sicherheit-und-einbruchschutz.vue' /* webpackChunkName: "pages/sicherheit-und-einbruchschutz" */))
const _c903e8a6 = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _088450ba = () => interopDefault(import('../pages/smarte-gemuetlichkeit.vue' /* webpackChunkName: "pages/smarte-gemuetlichkeit" */))
const _50e7f844 = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _1785cfde = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _3bbdb05e = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _4f467f15 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _2fbe3ed4 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _bdeb87cc = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _271a9f84 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _57cab242 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _7a20659b = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _9dea7bf2 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _697fba4e = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _09d7fe33 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _73a02024 = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _01e4a53f = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _09f8aba1 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _46755bb2 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _6e407d28 = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _215c08b4 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _0bff331a = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _fb9365bc = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _0b8b345c = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _13ad5703 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _5ef7820e = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _0c3dea52 = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _54c8570f = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _4b458088 = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _091dc4e8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _a4d4729a,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _faeaaf38,
    name: "anker"
  }, {
    path: "/apple-iphone-17-zubehoer",
    component: _0b2f08fe,
    name: "apple-iphone-17-zubehoer"
  }, {
    path: "/google",
    component: _dfd87454,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _b912827a,
    name: "handyrechnung-aktion"
  }, {
    path: "/infos-zum-online-kauf",
    component: _3ba07298,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _4245c694,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _05803029,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _8c6fd928,
    name: "merkliste"
  }, {
    path: "/newsletter",
    component: _4922ef13,
    name: "newsletter"
  }, {
    path: "/panzerglass",
    component: _c90d6b30,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _4dc76a18,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _ff3a89da,
    name: "samsung"
  }, {
    path: "/sicherheit-und-einbruchschutz",
    component: _75450ff8,
    name: "sicherheit-und-einbruchschutz"
  }, {
    path: "/smart-home-entdecken",
    component: _c903e8a6,
    name: "smart-home-entdecken"
  }, {
    path: "/smarte-gemuetlichkeit",
    component: _088450ba,
    name: "smarte-gemuetlichkeit"
  }, {
    path: "/soundcore",
    component: _50e7f844,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _1785cfde,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _3bbdb05e,
    name: "themenwelten"
  }, {
    path: "/xiaomi",
    component: _4f467f15,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _2fbe3ed4,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _bdeb87cc,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _271a9f84,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _57cab242,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _7a20659b,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _9dea7bf2,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/samsung/product-data",
    component: _697fba4e,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _09d7fe33,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _73a02024,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _01e4a53f,
    name: "shop-fehler"
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _09f8aba1,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _46755bb2,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _6e407d28,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _215c08b4,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _0bff331a,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _fb9365bc,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _0b8b345c,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _13ad5703,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _5ef7820e,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _0c3dea52,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/shop/kundenformular/persoenliche-daten",
    component: _54c8570f,
    name: "shop-kundenformular-persoenliche-daten"
  }, {
    path: "/shop/kundenformular/zahlungsart",
    component: _4b458088,
    name: "shop-kundenformular-zahlungsart"
  }, {
    path: "/",
    component: _091dc4e8,
    name: "index"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
